import { useCurrentModule } from '../components';
import { PERSONALIZED_CONTENT_QUERY_OPTIONS, useIsPersonalizedContentEnabled, usePersonalizedParams } from './usePersonalizedParams';
import { useReportQueryError } from './useReportQueryError';

/**
 * The one `/get-personalized-content` request behind the title, descriptions
 * and features hooks. All three call this with the same params, so react-query
 * dedupes them into one request per page.
 *
 * Two separate questions, answered here once so the three surfaces cannot
 * disagree: `enabled` decides whether the request goes out — both arms, so
 * the control arm's served-state is logged — and `isEnabled` decides whether
 * the user is shown the answer. Only the second gates `isLoading`: the control
 * arm must never wait on a response it will discard.
 */
export const usePersonalizedContent = () => {
  const module = useCurrentModule();
  const isEnabled = useIsPersonalizedContentEnabled();
  const {
    params,
    enabled,
    isLoading: isParamsLoading
  } = usePersonalizedParams();
  const reportQueryError = useReportQueryError();
  const {
    data,
    isSuccess,
    isError,
    isLoading: isQueryLoading
  } = module.SDK.personalizedContentApiClient.hooks.useGetPersonalizedContent(params, enabled, {
    ...PERSONALIZED_CONTENT_QUERY_OPTIONS,
    onError: error => reportQueryError('getPersonalizedContent', error)
  });
  const hasSettled = isSuccess || isError;
  const isRequestPending = enabled && (!hasSettled || isQueryLoading);
  return {
    data,
    isEnabled,
    isLoading: isEnabled && (isParamsLoading || isRequestPending)
  };
};
//# sourceMappingURL=usePersonalizedContent.js.map